export const msalConfig = {
  auth: {
    clientId: "9c1ef2fb-8a1c-46a2-9312-d0786722f417",
    authority:
      "https://login.microsoftonline.com/02f98226-2b37-483d-acf8-320c949b2e9d",
    redirectUri: "https://demo.itsneobot.com:4000/team/callback", // Update with your redirect URI
  },
};
